import { IconButton } from '@/components/forms/IconButton';

/** Sino com contador. `count` 0 esconde o selo. */
export function NotificationBell({ count = 0, plain = false, onClick }: { count?: number; plain?: boolean; onClick?: () => void }) {
  return <IconButton icon="bell" label={count ? `Notificações (${count} novas)` : 'Notificações'} variant={plain ? 'plain' : 'outline'} badge={count || undefined} onClick={onClick} />;
}
